const BOM = {
    window: window,
    document: document
};
//
BOM.alert = function(msg) {
    BOM.window.alert(msg);
};
//
BOM.log = function(msg) {
    if (typeof console != 'undefined') {
        console.log(msg);
    }
};
//
export { BOM };